module.exports = __webpack_public_path__ + "img/08.90f5d936.png";